export enum WarehouseReceiptListAction {
  Create,
}
